import { IBookmark, JobTaxonomyType } from '@careerhub/api';
import { IAction, IActionSuccess, IActionFailed, IActionWithParam } from '../common.types';

export enum CareerActionType {
  LOAD_BOOKMARKS = 'LOAD_BOOKMARKS',
  LOAD_BOOKMARKS_SUCCESS = 'LOAD_BOOKMARKS_SUCCESS',
  LOAD_BOOKMARKS_FAILED = 'LOAD_BOOKMARKS_FAILED',
  LOAD_TAXONOMYTYPE = 'LOAD_TAXONOMYTYPE',
  LOAD_TAXONOMYTYPE_SUCCESS = 'LOAD_TAXONOMYTYPE_SUCCESS',
  LOAD_TAXONOMYTYPE_FAILED = 'LOAD_TAXONOMYTYPE_FAILED',
  ADD_BOOKMARK = 'ADD_BOOKMARK',
  ADD_BOOKMARK_SUCCESS = 'ADD_BOOKMARK_SUCCESS',
  ADD_BOOKMARK_FAILED = 'ADD_BOOKMARK_FAILED',
  REMOVE_BOOKMARK = 'REMOVE_BOOKMARK',
  REMOVE_BOOKMARK_SUCCESS = 'REMOVE_BOOKMARK_SUCCESS',
  REMOVE_BOOKMARK_FAILED = 'REMOVE_BOOKMARK_FAILED',

  // TODO move this out of this reducer?
  // Update reducer logic away from Redux entirely?
  TOGGLE_CHAT = 'TOGGLE_CHAT',
}

/**
 * Get the user's bookmarks--fetch if we haven't fetched yet.
 * If we've already fetched, return the cached bookmarks.
 */
export function loadBookmarks(): IAction {
  return {
    type: CareerActionType.LOAD_BOOKMARKS,
  };
}

export function loadBookmarksSuccess(bookmarks: IBookmark[]): IActionSuccess<IBookmark[]> {
  return {
    type: CareerActionType.LOAD_BOOKMARKS_SUCCESS,
    payload: bookmarks,
  };
}

export function loadBookmarksFailed(errorMessage: string): IActionFailed {
  return {
    type: CareerActionType.LOAD_BOOKMARKS_FAILED,
    errorMessage,
  };
}
export function loadTaxonomyType(): IAction {
  return {
    type: CareerActionType.LOAD_TAXONOMYTYPE,
  };
}

export function loadTaxonomyTypeSuccess(taxonomyType: JobTaxonomyType[]): IActionSuccess<JobTaxonomyType[]> {
  return {
    type: CareerActionType.LOAD_TAXONOMYTYPE_SUCCESS,
    payload: taxonomyType,
  };
}

export function loadTaxonomyTypeFailed(errorMessage: string): IActionFailed {
  return {
    type: CareerActionType.LOAD_TAXONOMYTYPE_FAILED,
    errorMessage,
  };
}

export function addBookmark(id: string): IActionWithParam<string> {
  return {
    type: CareerActionType.ADD_BOOKMARK,
    param: id,
  };
}

export function addBookmarkSuccess(id: string): IActionSuccess<string> {
  return {
    type: CareerActionType.ADD_BOOKMARK_SUCCESS,
    payload: id,
  };
}

export function addBookmarkFailed(errorMessage: string): IActionFailed {
  return {
    type: CareerActionType.ADD_BOOKMARK_FAILED,
    errorMessage,
  };
}

export function removeBookmark(id: string): IActionWithParam<string> {
  return {
    type: CareerActionType.REMOVE_BOOKMARK,
    param: id,
  };
}

export function removeBookmarkSuccess(id: string): IActionSuccess<string> {
  return {
    type: CareerActionType.REMOVE_BOOKMARK_SUCCESS,
    payload: id,
  };
}

export function removeBookmarkFailed(errorMessage: string): IActionFailed {
  return {
    type: CareerActionType.REMOVE_BOOKMARK_FAILED,
    errorMessage,
  };
}

/** Show or hide the copilot chat */
export function toggleChat(): IAction {
  return {
    type: CareerActionType.TOGGLE_CHAT,
  };
}
